import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { PaymentConditionDataForm } from '../../../../app/models/PaymentCondition';

type Props = {
    paymentConditionDataForm: PaymentConditionDataForm;
    setPaymentConditionDataForm: (paymentCondition: PaymentConditionDataForm) => void;
    errorFields?: any;
};

const PaymentConditionForm = ({
    paymentConditionDataForm,
    setPaymentConditionDataForm,
    errorFields
}: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setPaymentConditionDataForm({ ...paymentConditionDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={paymentConditionDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre de la condición de pago"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentConditionForm;
